import { render, staticRenderFns } from "./researchAndInsightsDialog.vue?vue&type=template&id=3602ba94&scoped=true&"
import script from "./researchAndInsightsDialog.vue?vue&type=script&lang=js&"
export * from "./researchAndInsightsDialog.vue?vue&type=script&lang=js&"
import style0 from "./researchAndInsightsDialog.vue?vue&type=style&index=0&id=3602ba94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3602ba94",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QScrollArea,QIcon,QBtn,QImg,QCheckbox});qInstall(component, 'directives', {Ripple});
